import axiosInstance from '../auth/axiosInstance';

export const fetchReports = async (projectId) => {
  try {
    const { data } = await axiosInstance.get(`/Report/get-reports/${projectId}`);
    return data;
  } catch (error) {
    console.error('Error fetching reports:', error);
    throw error;
  }
};

export const fetchReportBlob = async (projectId, reportId) => {
  const response = await axiosInstance.get(
    `/Report/${projectId}/download-report/${reportId}`,
    { responseType: 'blob' }
  );

  const contentType = response.headers['content-type'] || '';
  if (contentType.includes('application/json') || contentType.includes('text/plain')) {
    const text = await response.data.text();
    let message = text;
    try {
      const parsed = JSON.parse(text);
      message = parsed?.message || parsed?.title || text;
    } catch {
      // keep raw text
    }
    throw new Error(message || 'Failed to load report file.');
  }

  return response.data;
};

export const downloadReport = async (projectId, reportId, filename) => {
  try {
    const fileBlob = await fetchReportBlob(projectId, reportId);

    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = URL.createObjectURL(fileBlob);
    link.setAttribute('download', filename || 'report.pdf');
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
    link.remove();
  } catch (error) {
    console.error('Error downloading the file:', error.message);
    alert(`Failed to download the file. Error: ${error.message}`);
    throw error;
  }
};
